import React, { useState, useContext, useEffect } from 'react';
import { Accordion, Card, AccordionContext, useAccordionToggle, Tab, Col, Nav, Button, Alert, Badge } from 'react-bootstrap';
import './index.scss';
import Historico from './historico';
import InformacoesCadastrais from "./InformacoesCadastrais";
import Produto from "./produto";
import Documentacao from './documentacao';
import Contrato from './contrato';
import Financeiro from './financeiro';
import ModalDommus from "../../../../components/Modal";
import NovoChamado from '../DadosDetalhes/AbrirChamado';
import MenuDetalhes from '../MenuDetalhes';
import { AtendimentoContext } from '../../../../contexts/AtendimentoContext';
import Alertas from './alertas';
import { CardOutroAtendimento } from '../../../../components/CardOutroAtendimento';
import caAPI from '../../../../services/caAPI';
import Swal from 'sweetalert2';
import { VinculoChamado } from './VinculoChamado';
import { ChamadosVinculados } from './ChamadosVinculados';
import { mascararCpfOuCnpj } from '../../../../components/InputTextMask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { trackPromise } from 'react-promise-tracker';
import { ModeloImpressaoService } from '../../../../services/ModeloImpressaoService';
import { AdicionarMarcadoresConclusaoAtendimento } from '../../AdicionarMarcadoresConclusaoAtendimento';


function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);  
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div
      style={{
        backgroundColor: isCurrentEventKey ? '#265d9c' : 'rgba(0,0,0,.03)',
        color: isCurrentEventKey ? 'white' : 'black',
        padding: '.75rem 1.25rem',
        marginbottom: '0',
        borderbottom: '1px solid rgba(0,0,0,.125)'
      }}
      onClick={decoratedOnClick}
    >
      {children}
    </div>
  );
}

export default function DadosDetalhes({ tipoDetalhes,cliente, titleToggle, handleSelecionaProcesso, handleSetClienteDadosProcesso, idProcesso, idAtendimento }) {

  const [dadosCliente, setDadosCliente] = useState(cliente);
  const [novoChamado, setOpenNovoChamado] = useState(false);
  const [outrosAtendimentos, setOutrosAtendimentos] = useState([]);
  const [atendimentosPorProcesso, setAtendimentosPorProcesso] = useState([]);
  const [openModalVinculoChamado, setOpenModalVinculoChamado] = useState(false);
  const [abrirChamadosVinculados, setAbrirChamadosVinculados] = useState(false);
  const [ openModalAdicionarMarcadores, setOpenModalAdicionarMarcadores] = useState(false);
  const { atendimentoAtivo, salvarAtendimentoFinalizado, finalizarAtendimento} = useContext(AtendimentoContext);
  
  const idProcessoExibido = (dadosCliente && dadosCliente.id_processo_visualizado) || atendimentoAtivo?.processo;
  const visualizandoOutroProcesso = !!idProcessoExibido && String(idProcessoExibido) !== String(atendimentoAtivo?.processo);


  useEffect(() => {
    setDadosCliente(cliente)
  }, [atendimentoAtivo, cliente, titleToggle])

  useEffect(()=>{
      caAPI.atendimento.buscarOutrosAtendimento(atendimentoAtivo.id).then((response)=>{
        setOutrosAtendimentos(response.data);
      }).catch((erro)=>{
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao carregar outros atendimentos " + erro,
          icon: 'error'
      });
      })
  },[atendimentoAtivo])

  useEffect(()=>{
    if(visualizandoOutroProcesso){
      trackPromise(
        caAPI.atendimento.buscarOutrosAtendimentosPorProcesso(idProcessoExibido).then((response)=>{
          setAtendimentosPorProcesso(Array.isArray(response.data) ? response.data : []);
        }).catch(()=>{
          setAtendimentosPorProcesso([]);
        })
      )
    }else{
      setAtendimentosPorProcesso(outrosAtendimentos?.processo || []);
    }
  },[visualizandoOutroProcesso, idProcessoExibido, outrosAtendimentos])
  
  const handleSelectAccordion = (item) => {
    if(item === "ChamadosVinculados"){
      setAbrirChamadosVinculados((current) => !current);
    }else if(abrirChamadosVinculados){
      setAbrirChamadosVinculados(false);
    }
  }

  const handleSolicitarExtratoFinanceiro = (e)=>{
    Swal.fire({
      titleText: `Solicitar extrato financeiro?`,
      text: "",
      icon: "question",
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "Sim, gerar!",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-primary mr-3",
        cancelButton: "btn btn-secondary mr-3",
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed && cliente?.proponentes?.[0]?.cpf) {
        trackPromise(ModeloImpressaoService.gerarModeloImpressaoPorProcesso(idProcessoExibido, 22, cliente?.proponentes?.[0]?.cpf)).then((response)=>{
            if(response?.data?.length){
              window.open(response.data, '_blank', 'noreferrer');
            }else{
              Swal.fire(
                'Ooops... Nenhum modelo de impressão encontrado.',
                '',
                'warning'
              )
            }
          }).catch(()=>{
          Swal.fire(
            'Ooops... Ocorreu um erro ao imprimir o extrato financeiro.',
            '',
            'error'
          )
        });
      } else {
        return;
      }
    });
  }

  const handleFinalizarAtendimento = ()=>{
    const idAtendimento = atendimentoAtivo.id;
    const finalizado = { situacao: "4" };
    if(JSON.parse(caAPI.getLocalState('habilitaMarcadoresAposFinalizacao'))){
      setOpenModalAdicionarMarcadores(true);
    }else{
      Swal.fire({
        titleText: "Finalizar Atendimento",
        text: "Deseja finalizar o atendimento?",
        icon: 'question',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Sim, Finalizar',
        cancelButtonText: 'Não, manter',
        customClass: {
          confirmButton: 'btn btn-primary mr-3',
          cancelButton: 'btn btn-secondary mr-3',
        },
        buttonsStyling: false
      }).then(
        (result) => {
          if (result.value) {
            finalizarAtendimento(finalizado, idAtendimento);
          }
      })
    }
  }

  return (
    <>
        <div className='informacoes-atendimento-header'>
          <MenuDetalhes
            tipoDetalhes={tipoDetalhes}
            titleToggle={titleToggle}
            handleSetClienteDadosProcesso={handleSetClienteDadosProcesso}
            handleSelecionaProcesso={handleSelecionaProcesso}
            handleVincularChamado={()=>{setOpenModalVinculoChamado(true)}}
            link={dadosCliente.link_processo}
            idProcesso={atendimentoAtivo?.processo}
          />
        </div>
        <div className='processo-detalhes-section'>
        <div id='dadosDetalhes'>
          <Tab.Container id="left-tabs" defaultActiveKey="dados_cliente">
            <div className='conteudo'>
              <div className="menuClienteHistoricoTarefas">
                <Nav variant="pills" className="menu_direita">
                  <Col>
                    <Nav.Item>
                      <Nav.Link eventKey="dados_cliente">Cliente</Nav.Link>
                    </Nav.Item>
                  </Col>
                  <Col>
                    <Nav.Item>
                      <Nav.Link eventKey="historico">Histórico</Nav.Link>
                    </Nav.Item>
                  </Col>
                  <Col>
                    <Nav.Item>
                      <Nav.Link eventKey="tarefas">Tarefas</Nav.Link>
                    </Nav.Item>
                  </Col>
                </Nav>
              </div>
              <Tab.Content className='conteudo-detalhes-section'>
                <Tab.Pane eventKey="dados_cliente">
                  <div className="descricao-cliente" onClick={() => window.open(dadosCliente.link_processo, '_blank')}>
                    <span>{idProcessoExibido && `[#${idProcessoExibido.toString().padStart(5, '0')}]` || 'Processo não vinculado'}</span>
                    <span>{cliente?.produto?.unidade_descricao && cliente.produto.unidade_descricao || ''}</span>
                    <span>{cliente?.produto?.empreendimento_nome && cliente.produto.empreendimento_nome || ''}</span>
                    <span>{cliente?.proponentes?.[0]?.nome && cliente.proponentes[0].nome || ''}</span>
                    <span>{cliente?.proponentes?.[0]?.cpf && `(${mascararCpfOuCnpj(cliente.proponentes[0].cpf)})` || ''}</span>
                    <span>{cliente?.processo?.codigo_relacionamento && `(CR: ${cliente.processo.codigo_relacionamento})` || ''}</span>
                  </div>
                  <Accordion className="accordion pt-0" defaultActiveKey="info" onSelect={handleSelectAccordion}>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} eventKey="ChamadosVinculados">
                          Chamados Vinculados
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="ChamadosVinculados">
                        <Card.Body style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                          {abrirChamadosVinculados && 
                            <ChamadosVinculados idAtendimento={atendimentoAtivo.id}/>
                          }
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} className="accordion_iten" eventKey="info">
                          Informações Cadastrais
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="info">
                        <InformacoesCadastrais
                          clientes={dadosCliente.proponentes}
                          produto={dadosCliente.produto}
                          processoSubjudice={dadosCliente.processo?.processo_subjudice}
                        />
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} className="accordion_iten" eventKey="Produto">
                          Produto
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="Produto">
                        <Produto produto={dadosCliente.produto} />
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} eventKey="Documentacao">
                          Documentação
                        </ContextAwareToggle>
                      </div>
                      {Array.isArray(dadosCliente.documentacao) && (
                        <Accordion.Collapse eventKey="Documentacao">
                          <Documentacao documentacao={dadosCliente.documentacao} />
                        </Accordion.Collapse>
                      )}
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} eventKey="Contrato">
                          Contrato
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="Contrato">
                        <Contrato contrato={dadosCliente.contrato} />
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} eventKey="Financeiro">
                          <div className='financeiro-title'>
                            Financeiro
                            {idProcessoExibido && 
                              <Badge 
                                className="badge-imprimir-extrato"
                                onClick={(e)=>{
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleSolicitarExtratoFinanceiro()
                                }}
                              >
                                <FontAwesomeIcon icon={faPrint}/>
                                <span>Extrato Financeiro</span>
                              </Badge>
                            }
                          </div>
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="Financeiro">
                        <Financeiro financeiro={dadosCliente.financeiro} idProcesso={idProcessoExibido}/>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} className="accordion_iten" eventKey="alertas">
                          Alertas
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="alertas">
                        <Alertas alertas={dadosCliente.interacoes.alertas} />
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Tab.Pane>
                <Tab.Pane eventKey="historico">
                  <Accordion defaultActiveKey="HistoricoCliente">
                    <Card>
                      <div className="accordion_iten">
                        <ContextAwareToggle as={Card.Header} className="accordion_iten" eventKey="HistoricoCliente">
                          Histórico do Cliente
                        </ContextAwareToggle>
                      </div>
                      <Accordion.Collapse eventKey="HistoricoCliente">
                        <Card.Body>
                          <Historico />
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    {outrosAtendimentos?.chamados?.length ?
                      <Card>
                        <div className="accordion_iten">
                          <ContextAwareToggle as={Card.Header} eventKey="OutroAtendimentosPorChamado">
                            Outros Atendimentos Pelo Chamado
                          </ContextAwareToggle>
                        </div>
                        <Accordion.Collapse eventKey="OutroAtendimentosPorChamado">
                          <Card.Body style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                            {outrosAtendimentos?.chamados.length ?
                              outrosAtendimentos?.chamados.map((outroAtendimento, index)=>{
                                return (
                                  <CardOutroAtendimento atendimento={outroAtendimento} key={index}/>
                                )
                              })
                              :
                              <Alert variant='warning'>Não possui outros atendimentos!</Alert>
                            }

                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      :<></>
                    }                    
                    {atendimentosPorProcesso?.length ?
                      <Card>
                        <div className="accordion_iten">
                          <ContextAwareToggle as={Card.Header} eventKey="OutroAtendimentosPorProcesso">
                            Outros Atendimentos Pelo Processo
                          </ContextAwareToggle>
                        </div>
                        <Accordion.Collapse eventKey="OutroAtendimentosPorProcesso">
                          <Card.Body style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                            {atendimentosPorProcesso?.length ?
                              atendimentosPorProcesso?.map((outroAtendimento, index)=>{
                                return (
                                  <CardOutroAtendimento atendimento={outroAtendimento} key={index}/>
                                )
                              })
                              :
                              <Alert variant='warning'>Não possui outros atendimentos!</Alert>
                            }

                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      :<></>
                    } 
                  </Accordion>
                </Tab.Pane>
              </Tab.Content>
            </div>
          </Tab.Container>
        </div>
        <div >
          <Button onClick={() => setOpenNovoChamado(true)} className="btnAcoes">Abrir chamado</Button>
        </div>
      </div>
      <ModalDommus
        className="modalNovoChamado"
        open={novoChamado}
        size={"lg"}
        close={() => {
          setOpenNovoChamado(false);
        }}
        titulo={"Abertura de novo chamado"}
      >
        <NovoChamado
          corTop={"#265d9c"}
          corButton={"#4CAF50"}
          close={()=>{setOpenNovoChamado(false)}}
          nomeProponente={atendimentoAtivo.nome}
          numeroOPVProcesso={atendimentoAtivo.processo}
          numeroAtendimento={atendimentoAtivo.id}
          idProcesso={idProcesso}
          idAtendimento={idAtendimento}
          dadosProcesso={cliente}
          meioComunicacao={atendimentoAtivo.meio_comunicacao.slug}
          handleFinalizarAtendimento={handleFinalizarAtendimento}
        />
      </ModalDommus>
      <ModalDommus
        className="modalVinculoChamado"
        open={openModalVinculoChamado}
        size={"lg"}
        close={() => {
          setOpenModalVinculoChamado(false);
        }}
        titulo={"Vincular a chamado"}
      >
        <VinculoChamado
          atendimento={atendimentoAtivo}
        />
      </ModalDommus>
      <ModalDommus
        titulo="Informe os marcadores de conclusão deste atendimento"
        open={openModalAdicionarMarcadores}
        close={() => setOpenModalAdicionarMarcadores(false)}
        size="lg"
      >
        <AdicionarMarcadoresConclusaoAtendimento
          closeModal={()=>{setOpenModalAdicionarMarcadores(false)}}
          atendimento={atendimentoAtivo}
          salvarAtendimento={salvarAtendimentoFinalizado}
        />
      </ModalDommus>
    </>

  )
}
